<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-slate-50 text-slate-800">
    <div class="w-full max-w-5xl p-6 mx-auto">
      <AppHeader :currentDateTime="currentDateTime" />

      <!-- Main Content -->
      <main class="flex flex-col md:flex-row gap-12 mt-8 animate-fade-in-up" style="animation-delay: 0.2s">
        <AppSidebar />
        
        <section class="md:w-3/4 md:pl-8 font-inter">
          <div class="mb-10">
            <h1 class="text-4xl font-extrabold text-slate-900 tracking-tight mb-2">My AI Technology Radar</h1>
            <p class="text-lg text-slate-600">Tracking the evolution of AI tools, platforms, languages, and techniques.</p>
          </div>

          <!-- Circular Radar Visualization -->
          <RadarChart :items="posts" />

          <div class="mt-12 mb-8 flex items-center gap-4">
            <div class="h-px bg-slate-200 flex-1"></div>
            <h2 class="text-xl font-bold text-slate-400 uppercase tracking-widest">Detailed Blips</h2>
            <div class="h-px bg-slate-200 flex-1"></div>
          </div>

          <div class="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-300 before:to-transparent">
            <!-- Posts -->
            <div v-for="(post, index) in posts" :key="index" class="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active">
              <!-- Icon -->
              <div class="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-emerald-500 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 relative z-10">
                <span class="text-xs font-bold">{{ index + 1 }}</span>
              </div>
              
              <!-- Card -->
              <div class="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 bg-white rounded-2xl shadow-sm border border-slate-100 hover:shadow-md hover:border-emerald-200 transition-all duration-300">
                <div class="flex items-center justify-between mb-3">
                  <span class="text-sm font-semibold text-emerald-600 tracking-wide uppercase">{{ post.quadrant }}</span>
                  <span class="px-2.5 py-1 text-xs font-bold rounded-full" :class="getBadgeClass(post.status)">
                    {{ post.status }}
                  </span>
                </div>
                <a :href="post.href" target="_blank" class="hover:text-emerald-600 transition-colors">
                  <h3 class="text-xl font-bold text-slate-900 mb-2">{{ post.title }}</h3>
                </a>
                <p class="text-slate-600 leading-relaxed text-sm">{{ post.content }}</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <AppFooter class="mt-12" />
    </div>
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import AppSidebar from './AppSidebar.vue'
import RadarChart from './RadarChart.vue'
import radarData from '../../thoughtworks_radar.json'

export default {
  name: "AiRadarPage",
  components: {
    AppHeader,
    AppFooter,
    AppSidebar,
    RadarChart
  },
  data() {
    return {
      currentDateTime: '',
      updateInterval: null
    }
  },
  computed: {
    posts() {
      return radarData
        .filter(item => item.category === 'AI')
        .map(item => ({
          status: item.ring,
          title: item.name,
          content: item.description,
          quadrant: item.quadrant.replace(/-/g, ' '),
          href: item.href
        }))
    }
  },
  mounted() {
    this.updateDateTime()
    this.updateInterval = setInterval(this.updateDateTime, 1000)
  },
  beforeUnmount() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval)
    }
  },
  methods: {
    updateDateTime() {
      const now = new Date()
      this.currentDateTime = now.toISOString().replace('T', ' ').substr(0, 19)
    },
    getBadgeClass(status) {
      switch (status) {
        case 'Adopt': return 'bg-blue-100 text-blue-700';
        case 'Trial': return 'bg-purple-100 text-purple-700';
        case 'Assess': return 'bg-amber-100 text-amber-700';
        case 'Hold': return 'bg-rose-100 text-rose-700';
        default: return 'bg-slate-100 text-slate-700';
      }
    }
  }
};
</script>
